import React from 'react';
import { useLocation } from 'react-router-dom';
import { GroupSidebar, IconAgency } from '@esg/ui';
import { customerSidebarConstants } from '../../Constants';

export const CustomerSidebar: React.FC = () => {
    const location = useLocation();
    const currentPath = location.pathname;

    const updatedSidebarItems = customerSidebarConstants.map(item => {
        if (item.path === 'customer/subscriptions' && currentPath.includes('customer/subscriptions/branch')) {
            return {
                ...item,
                path: currentPath.replace(/^\//, '') 
            };
        }
        return item;
    });

    return (
        <GroupSidebar
            label='Customer B2B'
            sidebarItems={updatedSidebarItems} 
            Icon={<IconAgency.Menu.User />}
            border={true}
            defaultShowItem={true}
        />
    );
};